module.exports = __webpack_public_path__ + "static/media/3.adc4472b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/3.png
// module id = 990
// module chunks = 0